var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOureForDelevery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 17.8H43.1V12.5H54.5C55.9 12.5 57 13.6 57 15V15.3C57 16.6 55.9 17.8 54.5 17.8Z",
    fill: "#D2D3D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 18.8H43.1C42.5 18.8 42.1 18.4 42.1 17.8V12.5C42.1 11.9 42.5 11.5 43.1 11.5H54.5C56.4 11.5 58 13.1 58 15V15.3C58 17.2 56.4 18.8 54.5 18.8ZM44.1 16.8H54.5C55.3 16.8 56 16.1 56 15.3V15C56 14.2 55.3 13.5 54.5 13.5H44.1V16.8Z",
    fill: "#202124"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8 17.8H26.5C25.1 17.8 24 16.7 24 15.3V15C24 13.6 25.1 12.5 26.5 12.5H36.8V17.8Z",
    fill: "#D2D3D3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9 18.8H26.5C24.6 18.8 23 17.2 23 15.3V15C23 13.1 24.6 11.5 26.5 11.5H36.8C37.4 11.5 37.8 11.9 37.8 12.5V17.8C37.9 18.3 37.4 18.8 36.9 18.8ZM26.5 13.4C25.7 13.4 25 14.1 25 14.9V15.2C25 16 25.7 16.7 26.5 16.7H35.8V13.4H26.5V13.4Z",
    fill: "#202124"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 57.4C26.1 57.4 25 56.3 25 54.9V35.9C25 28.9 28.6 22 36.7 22H43.2C51.3 22 55 29 55 35.9V54.9C55 56.3 53.9 57.4 52.5 57.4H27.5Z",
    fill: "#E4002B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 58.4H27.5C25.5 58.4 24 56.8 24 54.9V35.9C24 28.5 27.9 21 36.7 21H43.2C52.1 21 56 28.5 56 35.9V54.9C56 56.8 54.4 58.4 52.5 58.4ZM36.7 23C29.3 23 26 29.4 26 35.9V54.9C26 55.7 26.7 56.4 27.5 56.4H52.5C53.3 56.4 54 55.7 54 54.9V35.9C54 29.4 50.7 23 43.3 23H36.7Z",
    fill: "#202124"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7999 65H38.2999C36.2999 65 34.7 63.4001 34.7 61.4001V51C34.7 48.7 36.6 46.8 38.9 46.8H41.2C43.5 46.8 45.4 48.7 45.4 51V61.4001C45.3 63.4001 43.7999 65 41.7999 65Z",
    fill: "#4D4D50"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7999 66H38.2999C35.7999 66 33.7 63.9001 33.7 61.4001V51C33.7 48.1 36 45.8 38.9 45.8H41.2C44.1 45.8 46.4 48.1 46.4 51V61.4001C46.4 62.6001 45.8999 63.8 45.0999 64.6C44.2999 65.4 42.9999 66 41.7999 66ZM38.9 47.8C37.1 47.8 35.7 49.2 35.7 51V61.4001C35.7 62.8001 36.8999 64 38.2999 64H41.7999C42.4999 64 43.0999 63.7001 43.5999 63.2001C44.0999 62.7001 44.3999 62.1001 44.2999 61.4001V51C44.2999 49.2 42.8999 47.8 41.0999 47.8H38.9Z",
    fill: "#202124"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40 24.2C44.7497 24.2 48.6 20.3496 48.6 15.6C48.6 10.8504 44.7497 7 40 7C35.2504 7 31.4 10.8504 31.4 15.6C31.4 20.3496 35.2504 24.2 40 24.2Z",
    fill: "#E4002B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40 25.2C34.7 25.2 30.4 20.9 30.4 15.6C30.4 10.3 34.7 6 40 6C45.3 6 49.6 10.3 49.6 15.6C49.6 20.9 45.3 25.2 40 25.2ZM40 8C35.8 8 32.4 11.4 32.4 15.6C32.4 19.8 35.8 23.2 40 23.2C44.2 23.2 47.6 19.8 47.6 15.6C47.6 11.4 44.2 8 40 8Z",
    fill: "#202124"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40 20.4C42.6509 20.4 44.7999 18.251 44.7999 15.6C44.7999 12.9491 42.6509 10.8 40 10.8C37.349 10.8 35.2 12.9491 35.2 15.6C35.2 18.251 37.349 20.4 40 20.4Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40 21.4C36.8 21.4 34.2 18.8 34.2 15.6C34.2 12.4 36.8 9.80005 40 9.80005C43.2 9.80005 45.7999 12.4 45.7999 15.6C45.7999 18.8 43.2 21.4 40 21.4ZM40 11.8C37.9 11.8 36.2 13.5 36.2 15.6C36.2 17.7 37.9 19.4 40 19.4C42.1 19.4 43.7999 17.7 43.7999 15.6C43.7999 13.5 42.1 11.8 40 11.8Z",
    fill: "#202124"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32 51C31.4 51 31 50.5 31 50V46.4C31 41.8 34.8 38 39.4 38H40.6C45.2 38 49 41.8 49 46.4V50C49 50.6 48.5 51 48 51H32Z",
    fill: "#E4002B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52H32C30.9 52 30 51.1 30 50V46.4C30 41.2 34.2 37 39.4 37H40.6C45.8 37 50 41.2 50 46.4V50C50 51.1 49.1 52 48 52ZM39.4 39C35.3 39 32 42.3 32 46.4V50H48V46.4C48 42.3 44.7 39 40.6 39H39.4Z",
    fill: "#202124"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6 42C43 42 45 44 45 46.4Z",
    fill: "#E4002B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45 47.4C44.4 47.4 44 47 44 46.4C44 44.5 42.5 43 40.6 43C40 43 39.6 42.6 39.6 42C39.6 41.4 40 41 40.6 41C43.6 41 46 43.4 46 46.4C46 46.9 45.6 47.4 45 47.4Z",
    fill: "#202124"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M63 74C63 76.2091 52.7026 78 40 78C27.2975 78 17 76.2091 17 74C17 71.7909 27.2975 70 40 70C52.7026 70 63 71.7909 63 74Z",
    fill: "#D2D3D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOureForDelevery);
export default __webpack_public_path__ + "static/media/oure-for-delevery.5ba1c9e42b94e44a0370de11268bb3b4.svg";
export { ForwardRef as ReactComponent };